export const config = {
  title: "Sincere Exchange LLC | Compassionate Support in San Bernardino, CA",
  meta: {
    description:
      "Sincere Exchange LLC offers a safe, judgment-free space in San Bernardino, CA, for individuals dealing with anger and domestic violence issues, providing guidance and support.",
    keywords: [
      'Anger Management San Bernardino',
      'Domestic Violence Support',
      'Sincere Exchange LLC',
      'Emotional Support Services',
      'Safe Space Counseling',
      'Judgment-Free Support',
      'Emotional Well-being',
      'Conflict Resolution',
      'Personal Growth',
      'Mental Health Support'
    ],
    author: "Sincere Exchange LLC",
    canonicalUrl: 'https://sincereexchangellc.com/',
  },
  sections: {
    header: {
      businessName: "Sincere Exchange LLC",
    },
    sectionB: {
      heroTitle: "Sincere Exchange LLC",
      heroSubtitle: 'Providing Compassionate Support in San Bernardino, CA',
      learnAboutText: 'Learn About Our Services',
      phoneNumber: '3109248956',
      phoneLabel: '(310) 924-8956',
      heroBackgroundImage:
        "https://media.istockphoto.com/id/889113776/photo/providing-compassion-during-difficult-times.jpg?s=612x612&w=0&k=20&c=QNMLZ4MlbAKOkarX9gY7zCbQ0gc2GTc_ZHYi-z3corg=",
      cardData: [
        {
          title: 'Our Mission',
          description: 'At Sincere Exchange LLC, we aim to provide a safe, judgment-free space for individuals to explore their feelings and experiences related to anger and domestic violence.',
        },
        {
          title: 'Our Vision',
          description: 'We envision a community where open dialogue leads to healing and personal growth, empowering individuals to navigate their emotions healthily.',
        },
        {
          title: 'Why Choose Us',
          description: 'With personal experience and understanding, we offer compassionate guidance to help you channel your emotions constructively.',
        },
      ],
      description:
        "Sincere Exchange LLC specializes in providing support for individuals dealing with anger and domestic violence issues, offering a safe space to share experiences and find healthier ways to manage emotions.",
    },
    sectionC: {
      servicesTitle: 'Our Services',
      servicesDescription:
        "Explore the range of support services we offer to help you navigate your emotional well-being.",
      cards: [
        {
          title: 'Anger Management Support',
          description: 'Providing guidance and strategies to help you manage and channel your anger constructively.',
          imageSrc: 'https://media.istockphoto.com/id/2152639637/photo/female-employees-who-make-mistakes-are-scolded-and-shouted-at-by-angry-bosses-or-co-workers.jpg?s=612x612&w=0&k=20&c=6Pa44G4iM5VE0sM7-dZ2H_fpS2Wf_t0M6Tqgn0VNxH0=',
          imageAlt: 'Anger Management Support',
        },
        {
          title: 'Domestic Violence Support',
          description: 'Offering a safe space to discuss and navigate experiences related to domestic violence.',
          imageSrc: 'https://media.istockphoto.com/id/1394602841/photo/cropped-side-view-a-couple-sitting-together-in-a-house-with-a-stressful-gesture-the-woman.jpg?s=612x612&w=0&k=20&c=ix9Es-z_NU5t_uRPaAzRw4yHCivuWlUA2uywXuRRRb0=',
          imageAlt: 'Domestic Violence Support',
        },
        {
          title: 'Emotional Well-being Counseling',
          description: 'Guiding you towards healthier ways to manage and express your emotions.',
          imageSrc: 'https://media.istockphoto.com/id/2082304554/photo/occupational-therapy.jpg?s=612x612&w=0&k=20&c=FziPlGPJHlYxz593zjEeT8fSTQXzDIERwHZYd_PK03Y=',
          imageAlt: 'Emotional Well-being Counseling',
        },
      ],
      otherServicesTitle: 'Additional Services',
      otherServicesList: [
        'Conflict Resolution',
        'Personal Growth Workshops',
        'Stress Management',
        'Communication Skills Development',
        'Self-Esteem Building',
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src: 'https://lirp.cdn-website.com/753a0a21/dms3rep/multi/opt/pexels-photo-30322435-842h.jpeg',
        alt: "Sincere Exchange LLC Team",
      },
      aboutText: [
        "Sincere Exchange LLC is dedicated to providing a safe, judgment-free space for individuals dealing with anger and domestic violence issues in San Bernardino, CA.",
        "With personal experience and understanding, our team is here to guide you through your journey towards healing and personal growth.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Sincere Exchange LLC Logo",
      businessName: "Sincere Exchange LLC",
      contact: {
        phone: '3109248956',
        phoneLabel: '(310) 924-8956',
        email: 'zsz@sincereexchangellc.com',
        website: 'https://sincereexchangellc.com/',
        address: '566 East 28 St, San Bernardino, CA 92404',
      },
      socialMedia: {
        facebook: null,
        instagram: null,
        twitter: null,
        linkedin: null,
        youtube: null,
        tiktok: null,
      },
    },
    sectionF: {
      address: '566 East 28 St, San Bernardino, CA 92404',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3154.123456789012!2d-117.289765!3d34.125678!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80c34a1234567890b%3A0x1234567890abcdef!2s566%20E%2028th%20St%2C%20San%20Bernardino%2C%20CA%2092404%2C%20USA!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus',
    },
  },
};

export default config;
